import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import RequireAuth from "@/components/RequireAuth";
import Threshold from "@/pages/Threshold";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import FolderDetail from "@/pages/FolderDetail";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminConsole from "@/pages/AdminConsole";
import Gridd from "@/pages/Gridd";
import Realities from "@/pages/Realities";
import RealityDetail from "@/pages/RealityDetail";
import Antecessores from "@/pages/Antecessores";
import Chronicle from "@/pages/Chronicle";
import TerraChronicle from "@/pages/TerraChronicle";
import TerraDispatchDetail from "@/pages/TerraDispatchDetail";
import StratumDetail from "@/pages/StratumDetail";
import VoiceLogs from "@/pages/VoiceLogs";
import VoiceLogDetail from "@/pages/VoiceLogDetail";

// Module-level constants — avoid re-creating these objects on every render
const TOAST_OPTIONS = {
  style: {
    background: "#0a0a0a",
    border: "1px solid #333",
    color: "#E3E1D9",
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: "0.75rem",
    letterSpacing: "0.1em",
    borderRadius: 0,
  },
};

const gated = (el) => (
  <Layout>
    <RequireAuth>{el}</RequireAuth>
  </Layout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public — the only door */}
            <Route path="/threshold" element={<Threshold />} />
            {/* Legacy admin URL still resolves to the same gate */}
            <Route path="/admin" element={<AdminLogin />} />

            {/* Gated — entire archive */}
            <Route path="/" element={gated(<Home />)} />
            <Route path="/archive" element={gated(<Archive />)} />
            <Route path="/archive/:id" element={gated(<FolderDetail />)} />
            <Route path="/entities" element={gated(<Entities />)} />
            <Route path="/entities/:id" element={gated(<EntityDetail />)} />
            <Route path="/realities" element={gated(<Realities />)} />
            <Route path="/realities/:id" element={gated(<RealityDetail />)} />
            <Route path="/the-terra-chronicle" element={gated(<TerraChronicle />)} />
            <Route path="/the-terra-chronicle/:id" element={gated(<TerraDispatchDetail />)} />
            <Route path="/strata/:roman" element={gated(<StratumDetail />)} />
            <Route path="/voices" element={gated(<VoiceLogs />)} />
            <Route path="/voices/:id" element={gated(<VoiceLogDetail />)} />
            <Route path="/chronicle" element={gated(<Chronicle />)} />
            <Route path="/antecessores" element={gated(<Antecessores />)} />
            <Route path="/admin/console" element={gated(<AdminConsole />)} />
            <Route path="/admin/gridd" element={gated(<Gridd />)} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
